/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setPassword} from '../api'

export const useMutationSetPassword = createReactQueryMutationHook('setPassword', setPassword)
